import { render, staticRenderFns } from "./addThroughTransportChannel.vue?vue&type=template&id=4f0ad834&"
import script from "./addThroughTransportChannel.vue?vue&type=script&lang=js&"
export * from "./addThroughTransportChannel.vue?vue&type=script&lang=js&"
import style0 from "./addThroughTransportChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0ad834')) {
      api.createRecord('4f0ad834', component.options)
    } else {
      api.reload('4f0ad834', component.options)
    }
    module.hot.accept("./addThroughTransportChannel.vue?vue&type=template&id=4f0ad834&", function () {
      api.rerender('4f0ad834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/throughTransport/components/addThroughTransportChannel.vue"
export default component.exports